import CrudReducer from './crudReducer';

const cr = new CrudReducer('lines_of_business');

const reducer = cr.Reducer;

export default reducer;
